import { Filter } from '~/evifields/src/types/Filter';
import { toSearchV3Filter } from '~/redux/api/methods/searchV3';
import { Nullable } from '~/types/Nullable';
import {
  BooleanQueryEntity,
  EntityQuery,
  FilterQueryEntity,
} from '~/types/OpenSearch';

import { SearchFilterRecord, SearchQuery } from '../types';
import { buildFilterQuery } from '../utils/build-query';
import {
  testIsBooleanTextSearch,
  testIsFilter,
  testIsSection,
} from '../utils/query';

export const OPERATORS_WITH_NO_VALUES = new Set([
  'is_blank',
  'is_not_blank',
  'is_true',
  'is_false',
]);

export const mapQueryToFilters = (
  query: SearchQuery,
  searchFilters: SearchFilterRecord,
): Filter[] => {
  return (query as EntityQuery[])
    .filter(
      (filter: EntityQuery): filter is FilterQueryEntity | BooleanQueryEntity =>
        testIsFilter(filter) || testIsBooleanTextSearch(filter),
    )
    .map((filter: FilterQueryEntity | BooleanQueryEntity) =>
      toSearchV3Filter(filter, searchFilters),
    );
};

export const mapFiltersToQuery = (filters: Filter[]) => {
  const query: SearchQuery = buildFilterQuery({
    booleanQuery: '',
    filters,
  });

  return query;
};

export const isActiveQuery = (query?: Nullable<SearchQuery>): SearchQuery => {
  if (!query?.length) return [];

  const isComplexQuery = query.some(testIsSection);

  if (isComplexQuery) {
    const result = [...query];
    while (result[result.length - 1]?.type === 'operator') {
      result.pop();
    }
    return result;
  }

  const isValidFilter = (item: EntityQuery) =>
    testIsFilter(item) &&
    item.operator &&
    (item.value?.value_list?.length > 0 ||
      OPERATORS_WITH_NO_VALUES.has(item.operator));

  const testIsValidBooleanTextSearch = (item: EntityQuery) =>
    testIsBooleanTextSearch(item) && (item.value?.length ?? 0) > 0;

  const validFilters = query.filter(
    (queryEntity) =>
      isValidFilter(queryEntity) || testIsValidBooleanTextSearch(queryEntity),
  );

  return validFilters.reduce((acc: any[], item: any, index: number) => {
    acc.push(item);
    if (index < validFilters.length - 1) {
      acc.push({ type: 'operator', value: 'and' });
    }
    return acc;
  }, []);
};
